export default function formatText (text) {
  return text
    .replace(/\\/g, '')
    .replace(/\r?\n/gm, "\\n")
    .replace(/;/gm, "\\;")
    .replace(/,/gm, "\\,")
}